// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___24hQ8","sidebar":"styles-module__sidebar___246_G","media":"styles-module__media___2L1mV"};